"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackMessage = exports.trackException = exports.identifyUser = exports.setLogRocket = exports.getLogRocket = void 0;
const isBrowser_1 = require("../utils/isBrowser");
const getLogRocket = () => {
    var _a;
    if ((0, isBrowser_1.isBrowser)()) {
        return (_a = window === null || window === void 0 ? void 0 : window.mgm) === null || _a === void 0 ? void 0 : _a.logRocketLogger;
    }
};
exports.getLogRocket = getLogRocket;
const setLogRocket = (logRocket) => {
    if ((0, isBrowser_1.isBrowser)()) {
        window.mgm = Object.assign(Object.assign({}, window.mgm), { logRocketLogger: logRocket });
    }
};
exports.setLogRocket = setLogRocket;
const identifyUser = (user) => {
    var _a;
    (_a = (0, exports.getLogRocket)()) === null || _a === void 0 ? void 0 : _a.identify(user.username, Object.assign({}, user));
};
exports.identifyUser = identifyUser;
const trackException = (error, tag, additionalInformation) => {
    var _a;
    (_a = (0, exports.getLogRocket)()) === null || _a === void 0 ? void 0 : _a.captureException(error, {
        tags: tag ? { 'exception-tag': tag } : {},
        extra: additionalInformation !== null && additionalInformation !== void 0 ? additionalInformation : {},
    });
};
exports.trackException = trackException;
const trackMessage = (message, tag, additionalInformation) => {
    var _a;
    (_a = (0, exports.getLogRocket)()) === null || _a === void 0 ? void 0 : _a.captureMessage(message, {
        tags: tag ? { 'message-tag': tag } : {},
        extra: additionalInformation !== null && additionalInformation !== void 0 ? additionalInformation : {},
    });
};
exports.trackMessage = trackMessage;
